import { useDisclosure } from '@mantine/hooks';
import { Modal, Button, Title, Text, Group, Stack, Center, Image } from '@mantine/core';
import { useSelector } from "react-redux";
import React, { useEffect } from "react";
import Cookies from 'js-cookie';
import { useNavigate } from "react-router-dom";
import { IconGift } from '@tabler/icons-react';

const ModalNotification = () => {
  const [opened, { open, close }] = useDisclosure(false);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const modalClosed = Cookies.get("promotional-modal");
  const navigate = useNavigate();

  const closeModal = () => {
    Cookies.set('promotional-modal', 'done', { expires: 2 / 24 }); // 2 hours
    close();
  };

  const handleRegister = () => {
    close();
    navigate("/get-started");
  };

  useEffect(() => {
    if (!modalClosed && !isAuthenticated) {
//      open();
    }
  }, [modalClosed, isAuthenticated, open]);

  return (
    <Modal
      opened={opened}
      onClose={closeModal}
      centered
      size="lg"
      overlayProps={{ backgroundOpacity: 0.55, blur: 3 }}
    >
      <Stack spacing="md">
        <Image
                src="https://images.unsplash.com/photo-1549520685-70830303fa4a?q=80&w=800&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="Happy laundry customer"
                height={150}
                fit="contain"
                radius="md"
              />

        <Button size="md" radius="md" onClick={handleRegister}>
          Get Started
        </Button>

        <Center>
          <Text size="sm" c="dimmed">
            Already have an account?{" "}
            <Text component="a" href="/login" c="blue" td="underline">
              Log in
            </Text>
          </Text>
        </Center>

        <Stack spacing="xs" align="center" mt="md">
            <Button
              variant="subtle"
              color="gray"
              size="xs"
              onClick={closeModal}
            >
              No thanks
            </Button>
        </Stack>
      </Stack>
    </Modal>
  );
};

export default ModalNotification;